import type { common as enCommon } from "../en/common";

export const common: typeof enCommon = {
  actions: {
    save: "Salva",
    saving: "Salvataggio…",
    cancel: "Annulla",
    create: "Crea",
    creating: "Creazione…",
    send: "Invia",
    sending: "Invio…",
    upgrade: "Esegui l'upgrade",
    back: "Indietro",
    open: "Apri",
    notNow: "Non ora",
    close: "Chiudi",
    manage: "Gestisci",
  },
  errors: {
    shopNotInitialized: "Negozio non inizializzato.",
    unknownIntent: "Intento sconosciuto",
    unknownAction: "Azione sconosciuta.",
    tryAgain: "Riprova.",
    tryAgainOrContactSupport: "Riprova oppure contatta l'assistenza se il problema persiste.",
    notFound: "Non trovato.",
  },
  misc: {
    notAvailable: "n/d",
    none: "Nessuno",
  },
  quoteStatus: {
    DRAFT: "Bozza",
    SENT: "Inviato",
    VIEWED: "Visualizzato",
    ACCEPTED: "Accettato",
    DECLINED: "Rifiutato",
    EXPIRED: "Scaduto",
    CANCELED: "Annullato",
  },
  dataSufficiency: {
    HIGH: "Alta",
    MEDIUM: "Media",
    LOW: "Bassa",
  },
};
